import React, {useEffect, useState} from "react";
import {Table} from "../table/table";
import {ScrollableShadow} from "./shadow/scrollable-shadow";
import {SCROLLABLE_TABLE} from "./scrollable-table.consts";
import {ScrollableTableHeaders} from "./scrollable-table-headers";


export const ScrollableTable = ({
                                  isGroup,
                                  shouldRenderTable,
                                  num,
                                  rows,
                                  RowComponent,
                                  rowComponentProps,
                                  headerComponentProps,
                                  isSmallView,
                                  hasNotMajorHeaders,
                                  shadowFirstClassName,
                                  disableScrolling,
                                  leftOffset,
                                  id
                                }) => {
  const ref = React.useRef();
  const [firstCellWidth, setFirstCellWidth] = useState(SCROLLABLE_TABLE.CELLS.competitorMin);
  const [tableWidth, setTableWidth] = useState(0);
  const [showShadow, setShowShadow] = useState(false);
  const container = document.querySelector(isGroup ? '#table-group-container' + num : '#table-container');

  useEffect(() => {
    let majorColumnsWidth = 0;
    const tableContainer: HTMLElement = document.querySelector(isGroup ? '#table-group-container' + num : '#table-container');
    const isScrollable: Boolean = !disableScrolling && ((tableContainer.scrollWidth > tableContainer.clientWidth) || (isSmallView && hasNotMajorHeaders))

    const relevantHeaders = ref.current?.querySelectorAll(`#scroll-table-major-header${!isSmallView ? ', #scroll-table-header' : ''}`);
    setShowShadow(isScrollable);

    if (isScrollable) {
      relevantHeaders?.forEach(element => majorColumnsWidth += element.getBoundingClientRect().width);
      const tableWidth = tableContainer.clientWidth;
      setTableWidth(tableWidth);

      if (majorColumnsWidth > 0) {
        const width: Number = tableWidth - majorColumnsWidth - SCROLLABLE_TABLE.CELLS.badge - 16;
        const cellWidth = width < SCROLLABLE_TABLE.CELLS.competitorMin ? SCROLLABLE_TABLE.CELLS.competitorMin : width
        setFirstCellWidth(cellWidth);
      }
    } else {
      setFirstCellWidth('100%');
    }
  }, [id, rows?.length, num]);

  const shadowProps = {
    scrollableElement: container,
    showShadow: showShadow,
    leftOffset,
    firstShadowMaxWidth: SCROLLABLE_TABLE.SHADOWS.firstMaxWidth,
    lastShadowMaxWidth: SCROLLABLE_TABLE.SHADOWS.lastMaxWidth,
    className: shadowFirstClassName,
    rowsLength: rows?.length,
    id
  }

  return (<ScrollableShadow {...shadowProps}>
    {
      shouldRenderTable ?
        <Table ref={ref}>
          <ScrollableTableHeaders {...headerComponentProps}/>
          {rows?.map((row, index: Number) => <RowComponent
            row={row}
            key={index}
            firstCellWidth={firstCellWidth}
            tableWidth={tableWidth}
            {...rowComponentProps}
          />)}
        </Table> : null
    }
  </ScrollableShadow>)
};
